import React, { useEffect, useState, useRef } from "react";
import { Dropdown } from "../components/Dropdown";
import { Paragraph } from "../components/Paragraph";
import { ShortAnswer } from "../components/ShortAnswer";
import { SubmitButton } from "../components/SubmitButton";
import { liff } from "@line/liff";
import "./style.css";
import RootLayout from "layouts/RootLayout";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import { submitConsultation } from "../apis/consultService";
import type { SubmitConsultationRequest } from "../types/consultation";
import { useTranslation } from "react-i18next";

// 諮詢問題：中文 canonical value（送後端）→ i18n key（顯示用）
const TOPIC_KEYS: Record<string, string> = {
    "新生兒照護": "newborn",
    "發燒": "fever",
    "呼吸道疾患": "respiratory",
    "腹痛": "abdominalPain",
    "腹瀉嘔吐": "diarrheaVomit",
    "腸病毒": "enterovirus",
    "外傷處理": "trauma",
    "皮膚紅疹": "rash",
    "泌尿道": "urinary",
    "五官(眼耳口鼻)": "facial",
    "其他問題": "other",
};

// 小孩資料（含 profile 帶入的幼兒專責醫師欄位）
type ClinicInfo = { code: string; name: string; isManual: boolean } | null;
type KidData = {
    name: string;
    age: string;
    weight: string;
    primary_medical: string;
    pediatricianStatus?: 'joined' | 'interested' | 'not_interested' | '';
    pediatricianClinic?: ClinicInfo;
};


const LIFF_ID = process.env.REACT_APP_FORM_LIFF_ID;
//EUcare Jake.chen
// const updateProfileUrl = 'https://script.google.com/macros/s/AKfycbzQRGTNUqI8QBkYt-5C5smS5czCK8OMY7iAJwSfSmMHQjeQQdA-NNLG7J_2EEKHcjIt/exec'
// twdata puppy
// const updateProfileUrl = 'https://script.google.com/macros/s/AKfycbwJ1cL-QqTZNLvD2H36QRrf2dMeWUH4gtMTOuiIm3o26NUf3hXvNG3CbS7g-e4vIbpE7g/exec'
// Nestjs backend
const updateProfileUrl = process.env.REACT_APP_PROFILE_UPDATE_URL;
const getAppProfileUrl = process.env.REACT_APP_PROFILE_GET_URL;

const FETCH_SUCCESS = 200;

const initializeLIFF = async () => {
    try {
        await liff.init({ liffId: LIFF_ID });

        if (!liff.isLoggedIn()) {
            liff.login();
        }

        if (!liff.isInClient()) {
            const discordWebhookUrl = process.env.REACT_APP_DISCORD_WEBHOOK_URL;
            if (discordWebhookUrl) {
                const displayName = (await liff.getProfile()).displayName || 'Guest'; // 防止 displayName 为空
                await fetch(discordWebhookUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                    },
                    body: JSON.stringify({
                        content: `LIFF ID: ${LIFF_ID}，有用戶被引導到「諮詢表單」，Line 名稱: ${displayName}，Line ID: ${liff.getContext().userId}`,
                    }),
                });
            }
            // window.location.href = `https://line.me/R/app/${LIFF_ID}`;
            // alert('諮詢表單請使用手機 LINE APP 開啟填寫，如您有緊急需求請撥打 119 或可參考下列就醫資訊詢問');
            // window.location.href = "https://klbaby.gocare.tw/clinicList";   // dev
            return liff;
        }
        return liff;
    } catch (error: unknown) {
        console.error('初始化 liff 時出錯：', error);
    }
};


export const ConsultForm = (): JSX.Element => {
    const { t } = useTranslation("consult");
    const topicOptionLabels = Object.fromEntries(
        Object.entries(TOPIC_KEYS).map(([zh, key]) => [zh, t(`topic.${key}`)])
    );
    const [liffClientObject, setLiffClientObject] = useState(null);
    // name of the user
    const [name, setName] = useState("");
    const [address, setAddress] = useState("");
    const [phone, setPhone] = useState("");
    const [topicSelected, setTopicSelected] = useState("");
    const [contentText, setContentText] = useState("");
    const [loading, setLoading] = useState(true);
    const [selectedKid, setselectedKid] = useState(0);
    const [kidData, setKidData] = useState<KidData[]>([{ name: '', age: '', weight: '', primary_medical: '', pediatricianStatus: '', pediatricianClinic: null }]);
    const [inputKidData, setInputKidData] = useState<KidData>({ name: '', age: '', weight: '', primary_medical: '', pediatricianStatus: '', pediatricianClinic: null })
    const [profileHaveData, setProfileHaveData] = useState(false);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);

    const formRef = useRef<HTMLFormElement>(null);
    const userId = liffClientObject?.getContext()?.userId
    const accessToken = liffClientObject?.getAccessToken()

    useEffect(() => {
        const initialize = async () => {
            const liffObject = await initializeLIFF();
            setLiffClientObject(liffObject);
        };
        initialize()
    }, []);



    useEffect(() => {

        if (userId === undefined) return
        if (accessToken === undefined) return

        const getProfileUrl = `${getAppProfileUrl}${userId}?access_token=${accessToken}`;

        fetch(getProfileUrl)
            .then(response => response.json())
            .then(data => {
                //有填過基本資料
                if (data.status_code === FETCH_SUCCESS) {
                    console.log(data)
                    setName(data.data.name);
                    setPhone(data.data.phone);
                    setAddress(data.data.address);
                    setKidData(data.data.childes);
                    setselectedKid(1);
                    setInputKidData(data.data.childes[0])
                    setProfileHaveData(true);
                }
                setLoading(false);
            });

    }, [userId, accessToken])



    const validate = () => {
        const form = formRef.current;
        if (form?.checkValidity()) {
            return true;
        } else {
            return false;
        }
    };

    const handleSelectKids = (e) => {
        const selectedValue = e.target.value
        setselectedKid(selectedValue);

        if (selectedValue === "請選擇") {
            setselectedKid(1);
        } else {
            const selectedKidIndex = kidData.findIndex(kid => kid.name === selectedValue);
            if (selectedKidIndex !== -1) {
                setInputKidData(kidData[selectedKidIndex]);
            } else {
                setselectedKid(1);
            }
        }
    };

    const handleKidsInput = (e: React.ChangeEvent<HTMLInputElement>, type: string) => {
        const temp = { ...inputKidData };
        temp[type] = e.target.value;
        setInputKidData(temp);
    }


    const handleSubmit = async (e: React.FormEvent) => {
        setLoading(true);
        e.preventDefault();

        if (!validate()) {
            setLoading(false);
            return;
        }

        if (!liffClientObject) {
            console.error('LIFF client object is not initialized');
            alert(t('alert.consultNetworkError'));
            setLoading(false);
            return;
        }

        try {
            const profile = await liffClientObject.getProfile();
            const lineName = profile.displayName || 'Guest';

            // 準備諮詢資料
            const requestData: SubmitConsultationRequest = {
                accessToken: accessToken,
                lineId: userId,
                line_name: lineName,
                name: name,
                phone: phone,
                address: address,
                child_name: inputKidData.name,
                year_selected: inputKidData.age,
                weight: inputKidData.weight,
                primary_medical: inputKidData.primary_medical,
                topic_selected: topicSelected,
                content_text: contentText
            };

            // 幼兒專責醫師：依送出規則帶入（joined 帶診所、其他狀態僅帶 status、未作答不帶）
            const pediatricianStatus = inputKidData.pediatricianStatus;
            if (pediatricianStatus === 'joined' || pediatricianStatus === 'interested' || pediatricianStatus === 'not_interested') {
                requestData.pediatrician_status = pediatricianStatus;
                if (pediatricianStatus === 'joined' && inputKidData.pediatricianClinic?.name) {
                    requestData.pediatrician_clinic_name = inputKidData.pediatricianClinic.name;
                    requestData.pediatrician_clinic_code = inputKidData.pediatricianClinic.code || '';
                }
            }

            // 呼叫 API 提交諮詢
            await submitConsultation(requestData);

            // 如果用戶是第一次填寫，同時更新用戶資料
            if (!profileHaveData) {
                await fetch(updateProfileUrl!, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                    },
                    body: JSON.stringify({
                        accessToken: accessToken,
                        profile: profile,
                        userId: userId,
                        name: name,
                        phone: phone,
                        address: address,
                        child_number: 1,
                        childes: [inputKidData]
                    })
                });
            }

            // 透過 LIFF 發送訊息觸發後端處理
            await liffClientObject.sendMessages([
                {
                    type: 'text',
                    text: '請協助諮詢回覆'
                }
            ]);

            setProfileHaveData(true);
            setLoading(false);

            // 顯示成功對話框
            setShowSuccessDialog(true);

        } catch (error) {
            setLoading(false);
            console.error('Submit consultation error:', error);
            alert(t('alert.consultNetworkError'));
        }
    };

    const handleSuccessDialogClose = () => {
        setShowSuccessDialog(false);
        liff.closeWindow();
    };

    const kidDropdown = kidData.map(kid => kid.name);

    return (
        <RootLayout title={t("nav.title")}>
            <form onSubmit={handleSubmit} ref={formRef}>
                <div style={{ display: 'flex', flexDirection: 'column', padding: '20px 44px', gap: '16px' }}>
                    <ShortAnswer className="" hasDiv={false} text={t("field.name")}
                        dataInput={name}
                        onChange={(e) => {
                            setName(e.target.value);
                        }}
                    />
                    <ShortAnswer className="" hasDiv={false} text={t("field.phone")}
                        dataInput={phone}
                        onChange={(e) => {
                            setPhone(e.target.value);
                        }}
                    />
                    <ShortAnswer className="" hasDiv={false} text={t("field.address")}
                        dataInput={address}
                        onChange={(e) => {
                            setAddress(e.target.value);
                        }}
                    />

                    {profileHaveData &&
                        <Dropdown
                            className=""
                            frame="/img/frame.svg"
                            frameClassName="dropdown-2"
                            hasDiv={false}
                            options={kidDropdown}
                            dataSelected={String(selectedKid)}
                            onChange={handleSelectKids}
                            text={t("field.selectChild")}
                        />
                    }


                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <ShortAnswer
                            className=""
                            hasDiv={false}
                            text={t("field.childName")}
                            dataInput={inputKidData.name}
                            onChange={(e) => handleKidsInput(e, 'name')}
                        />
                        <ShortAnswer
                            className=""
                            hasDiv={false}
                            text={t("field.age")}
                            dataInput={inputKidData.age}
                            onChange={(e) => handleKidsInput(e, 'age')}
                        />
                        <ShortAnswer
                            className=""
                            hasDiv={false}
                            text={t("field.weight")}
                            dataInput={inputKidData.weight}
                            onChange={(e) => handleKidsInput(e, 'weight')}
                        />
                        <ShortAnswer
                            className=""
                            hasDiv={false}
                            text={t("field.primaryMedical")}
                            dataInput={inputKidData.primary_medical}

                            onChange={(e) => handleKidsInput(e, 'primary_medical')}
                        />
                    </div>

                    {/* 幼兒專責醫師（唯讀，僅「已加入」才顯示診所；未加入狀態不顯示） */}
                    {inputKidData.pediatricianStatus === 'joined' && (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <label style={{ color: '#555555', fontSize: '20px', fontWeight: 'bold' }}>
                                {t("field.pediatrician")}{inputKidData.pediatricianClinic?.name || ''}
                            </label>
                            <p style={{ color: '#999999', fontSize: '12px', margin: 0 }}>
                                {t("pediatricianHint")}
                            </p>
                        </div>
                    )}

                    <Dropdown
                        className=""
                        frame="/img/frame-1.svg"
                        frameClassName="dropdown-2"
                        hasDiv={false}
                        options={["新生兒照護", "發燒", "呼吸道疾患", "腹痛", "腹瀉嘔吐", "腸病毒", "外傷處理", "皮膚紅疹", "泌尿道", "五官(眼耳口鼻)", "其他問題"]}
                        optionLabels={topicOptionLabels}
                        dataSelected={topicSelected}
                        onChange={(e) => {
                            setTopicSelected(e.target.value);
                        }}
                        text={t("field.topic")}
                    />

                    <Paragraph className="" hasDiv={false} text={t("field.note")}
                        dataText={contentText}
                        onChange={(e) => {
                            setContentText(e.target.value);
                        }}
                    />
                    <SubmitButton className="profileSubmitbtn" text={t("action.submit")} loading={loading} />
                </div>
            </form>
            <Dialog open={loading}>
                <DialogTitle >
                    {t("dialog.saving")}
                </DialogTitle>
            </Dialog>

            {/* 成功對話框 */}
            <Dialog open={showSuccessDialog} onClose={handleSuccessDialogClose}>
                <DialogTitle>{t("dialog.successTitle")}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {t("dialog.successText")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSuccessDialogClose} autoFocus>
                        {t("common:action.confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
        </RootLayout>
    );
};